import React, { useEffect, useContext } from 'react';
import ValueSetSidebar from './ValueSetSidebar';
import './PageValueSet.css';
import ValueSetBody from './ValueSetBody';
import QueryVSContextProvider from '../contexts/QueryVSContext';
import { GlobalContext } from '../contexts/GlobalContext';

function PageValueSet() {

	const globals = useContext(GlobalContext)

	useEffect(() => {
		globals.initAnalytics();
		globals.logPageAnalytics();
	}, [globals])

	return (
		<div className="pageValueSet">
			<QueryVSContextProvider>
				<ValueSetSidebar />
				<ValueSetBody />
			</QueryVSContextProvider>
		</div>
	);
}

export default PageValueSet;
